"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExtrasTileActions;
(function (ExtrasTileActions) {
    ExtrasTileActions["DataLoaded"] = "DataLoaded";
})(ExtrasTileActions || (ExtrasTileActions = {}));
exports.default = ExtrasTileActions;
